/**
 * Sorts installment offers by term (highest first) and then by APR (lowest first)
 * Also renumbers the program field based on the new sorted order
 * @param {Array} offers - Array of installment offers
 * @returns {Array} - Sorted array of installment offers with renumbered programs
 */
function sortInstallmentOffers(offers) {
  const sortedOffers = offers.sort((a, b) => {
    // Get the first term from each offer (assuming each offer has at least one term)
    const termA = a.terms[0]?.term || 0;
    const termB = b.terms[0]?.term || 0;
    const aprA = a.terms[0]?.apr || 0;
    const aprB = b.terms[0]?.apr || 0;

    // First sort by term (highest first)
    if (termA !== termB) {
      return termB - termA;
    }

    // If terms are the same, sort by APR (lowest first)
    return aprA - aprB;
  });

  // Renumber the program field based on the new sorted order
  return sortedOffers.map((offer, index) => {
    // Remove the original numbering from the program field
    const programWithoutNumber = offer.program.replace(/^\d+\.\s*/, '');

    return {
      ...offer,
      program: `${index + 1}. ${programWithoutNumber}`,
    };
  });
}

export default sortInstallmentOffers;
